import { render, staticRenderFns } from "./screenPopup.vue?vue&type=template&id=c4c0145e&scoped=true&lang=pug"
import script from "./screenPopup.vue?vue&type=script&lang=js"
export * from "./screenPopup.vue?vue&type=script&lang=js"
import style0 from "./screenPopup.vue?vue&type=style&index=0&id=c4c0145e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c0145e",
  null
  
)

export default component.exports